(function () {
  'use strict';

  angular
    .module('cabinPerformance')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('cabinPerformance', {
        url: '/cabin-performance',
        views: {
          'cabinPerformanceView': {
            templateUrl: 'cabin-performance/views/cabin-performance.tpl.html',
            controller: 'CabinPerformanceCtrl',
            controllerAs: 'cabinPerformance'
          }
        }
      });
  }
}());
